const OTHERS_LABEL_PATTERN = /^\d+ Others$/;
const COUNT_QUALIFIED_OTHERS_LABEL_PATTERN = /^\((\d+)\) (\d+) Others$/;

/**
 * Matches an Others group label, either "{n} Others" or the count-qualified
 * "({count}) {n} Others" (EVA-306 contract §5).
 */
export function isOthersGroupLabel(label: Maybe<string>): boolean {
  if (!label) return false;
  return (
    OTHERS_LABEL_PATTERN.test(label) || COUNT_QUALIFIED_OTHERS_LABEL_PATTERN.test(label)
  );
}
